import { apiClient, type PageEnvelope } from '@/lib/api-client';

export interface Mailbox {
  id: string;
  email: string;
  display_name: string | null;
  provider: string;
  status: string;
  daily_send_cap: number;
  hourly_send_cap: number;
  sends_today: number;
  sends_this_hour: number;
  reputation_score: number;
  last_send_at: string | null;
  cooldown_until: string | null;
  signature_html: string | null;
  created_at: string;
}

export interface MailboxPool {
  id: string;
  name: string;
  description: string | null;
  strategy: string;
  created_at: string;
  member_count?: number;
}

export const mailboxPoolsApi = {
  list: () =>
    apiClient.get<PageEnvelope<MailboxPool>>('/api/v1/mailbox-pools').then((r) => r.items),
  create: (input: { name: string; description?: string; mailbox_ids: string[] }) =>
    apiClient.post<MailboxPool>('/api/v1/mailbox-pools', input),
};

export const mailboxesApi = {
  list: () =>
    apiClient.get<PageEnvelope<Mailbox>>('/api/v1/mailboxes').then((r) => r.items),
  connectSmtp: (input: {
    email: string;
    password: string;
    display_name?: string;
    smtp_host?: string;
    smtp_port?: number;
    imap_host?: string;
    imap_port?: number;
    skip_consumer_check?: boolean;
  }) => apiClient.post<Mailbox>('/api/v1/mailboxes/connect-smtp', input),
  update: (id: string, input: Partial<Mailbox>) =>
    apiClient.patch<Mailbox>(`/api/v1/mailboxes/${id}`, input),
  delete: (id: string) => apiClient.del<void>(`/api/v1/mailboxes/${id}`),
  testSend: (id: string, input: { to: string; subject?: string; body_html?: string }) =>
    apiClient.post<{ message_id_header: string }>(
      `/api/v1/mailboxes/${id}/test-send`,
      input,
    ),
};
